(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/game/assets/javascripts/views/payfooter-online.js') >= 0) return;  svs.modules.push('/components/numbergames/game/assets/javascripts/views/payfooter-online.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const productMapping = svs.numbergames.productMapping;
const formatCurrency = svs.utils.format.Currency;
svs.numbergames.game.views.PayFooterOnline = Marionette.View.extend({
  modelEvents: {
    'change:isSubscription': 'changedIsSubscription',
    'change:syndicateId': 'updateBalance',
    'change:price': 'onPriceChange',
    'change:selectedDays': 'setIsNewRules'
  },
  behaviors() {
    return [{
      behaviorClass: svs.tur.start_subscription.behaviors.HandleSubscription,
      start: true,
      change: true
    }, {
      behaviorClass: svs.numbergames.game.behaviors.Payfooter,
      shouldShowSum: () => true,
      payButtonTitle: () => {
        if (this.model.get('isSubscription')) {
          if (this.model.get('subscriptionId')) {
            return 'Ändra ({amount} kr / vecka)';
          }
          if (!this.isNewRules && this.lottoRuleChangeDate) {
            return 'Starta prenumeration';
          }
          return 'Starta ({amount} kr / vecka)';
        }
        return 'Betala {amount} kr';
      },
      payfooterBalanceText: () => {
        if (this.model.get('isSubscription')) return '';
        if (this.model.get('isSyndicate')) return 'Vårt saldo: {amount} kr';
        return 'Mitt saldo: {amount} kr';
      },
      payfooterSumText: () => {
        if (this.model.get('isSubscription')) {
          if (!this.isNewRules && this.lottoRuleChangeDate) {
            return "Summa: {amount} kr / vecka fram till ".concat(this.lottoRuleChangeDate, ", d\xE4refter ").concat(formatCurrency(this.lottoRuleChangePrice), " kr / vecka");
          }
          return 'Summa: {amount} kr / vecka';
        }
        return 'Summa: {amount} kr';
      },
      analyticsEvents: this.getOption('analyticsEvents')
    }];
  },
  initialize() {
    svs.numbergames.game.logger.debug('PayFooter initialize');
    const promptPay = svs.utils.paramHandler.get({
      key: 'pay'
    }).value;
    if (promptPay && !svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) {
      svs.utils.paramHandler.remove({
        key: 'pay'
      });
      return;
    }
    if (promptPay && !this.model.get('numRowsExceedMax')) {
      svs.utils.paramHandler.remove({
        key: 'pay'
      });
      this.model.get('isValid') && this.triggerMethod('pay');
    }
    if (productMapping.isLotto(this.model.get('productId')) && svs.core.detect.feature('ft-lotto-rule-change')) {
      const closestRuleChangeRegOpenTime = Math.min(...svs.lotto.data.ruleChangeDraws.map(d => new Date(d.regOpenTime).getTime()));
      this.lottoRuleChangeDate = svs.utils.date.ShortDateAndTime(closestRuleChangeRegOpenTime, true, false);
      this.updateLottoRuleChangePrice();
      this.setIsNewRules();
    }
  },
  setIsNewRules() {
    var _svs$numbergames$draw;
    if (!productMapping.isLotto(this.model.get('productId')) && !svs.core.detect.feature('ft-lotto-rule-change')) {
      return;
    }
    let productItsId;
    if (this.model.get('selectedDays').length === 1) {
      productItsId = this.model.get('selectedDays')[0];
    } else {
      productItsId = svs.numbergames.game.draw.upcomingDrawProduct;
    }
    const {
      drawNumber,
      productId
    } = (_svs$numbergames$draw = svs.numbergames.draws.drawsApi.firstPlayableDraw(this.model.get('productId'))[productItsId]) !== null && _svs$numbergames$draw !== void 0 ? _svs$numbergames$draw : {};
    this.isNewRules = svs.numbergames.rules.utils.lotto.isNewRules({
      drawNumber,
      product: productId
    });
  },
  onPriceChange() {
    this.updateBalance();
    if (productMapping.isLotto(this.model.get('productId')) && svs.core.detect.feature('ft-lotto-rule-change')) {
      this.updateLottoRuleChangePrice();
    }
  },
  onPayfooterCreated() {
    this.updateBalance();
  },
  updateLottoRuleChangePrice() {
    this.lottoRuleChangePrice = this.model.get('price') + this.model.get('boards').getNumberOfValidBoards() * this.model.get('rowPriceMulti') * this.model.get('selectedDays').length;
  },
  async updateBalance() {
    if (!svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER)) return;
    try {
      const activeAcc = await svs.numbergames.accountSelector.getActiveAccount();
      this.triggerMethod('updatePayfooterBalance', parseInt(activeAcc.balance, 10));
    } catch (e) {
      svs.numbergames.game.logger.error(e);
    }
  },
  changedIsSubscription() {
    this.triggerMethod('updatePayButtonTitle');
    this.triggerMethod('updatePayfooterSum');
    this.triggerMethod('updatePayButtonState');
    this.updateBalance();
  },
  onPay() {
    var _this$model$get;
    svs.numbergames.game.logger.debug('User wants to pay');
    if (this.model.get('isSubscription')) {
      const prefix = this.model.has('subscriptionId') ? 'change' : 'start';
      const wagerObject = this.model.toObject();
      const subscriptionPackageId = this.model.getSubscriptionPackageId();
      const wager = _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, wagerObject), subscriptionPackageId), this.lottoRuleChangePrice && {
        lottoRuleChangePrice: this.lottoRuleChangePrice
      }), this.lottoRuleChangeDate && {
        lottoRuleChangeDate: this.lottoRuleChangeDate
      });
      const subscriptionObject = svs.numbergames.game_model.utils.subscriptionFromWager(wager);
      this.triggerMethod("".concat(prefix, "Subscription"), subscriptionObject);
      return;
    }
    const ticketsCollection = this.model.get('tickets');
    const [ticketModel] = ticketsCollection.selectedTickets();
    const ticketData = ticketModel === null || ticketModel === void 0 ? void 0 : ticketModel.get('ticketData');
    svs.numbergames.pay_numbergames.makePayment({
      onSuccessCb: () => this.model.removeFromLocalStorage(),
      onDoneCb: () => {
        const returnUrl = svs.utils.paramHandler.get({
          key: 'returnUrl'
        });
        if (returnUrl.value) {
          svs.utils.url.navigate("".concat(svs.utils.url.makeInternal(decodeURIComponent(returnUrl.value), svs.core.urlMapping.get('myBetsHome'))));
        } else {
          const relatedUrl = "".concat(svs.core.data.baseUrl, "/relaterat?grassrootstoasterredirect");
          svs.utils.url.navigate(relatedUrl);
        }
      },
      wagerData: {
        product: this.model.get('productId'),
        price: this.model.get('price'),
        drawCount: this.model.get('drawCount'),
        wagers: svs.numbergames.game.pay.toApiWagers(this.model.toObject()),
        prolongedWagerId: (_this$model$get = this.model.get('prolongedBet')) === null || _this$model$get === void 0 ? void 0 : _this$model$get.wagerId
      },
      ticketData
    });
  },
  onActivationSuccess() {
    this.model.removeFromLocalStorage();
  }
});

 })(window);